// extracted by mini-css-extract-plugin
export default {"Toolbar":"Toolbar_Toolbar__ucBZg","Logo":"Toolbar_Logo__y6iLp","DesktopOnly":"Toolbar_DesktopOnly__szvZU"};